import React, { Component } from 'react'
import PropTypes from 'prop-types'
import RCSlider from 'rc-slider/lib/Slider'
import _ from 'lodash'

import { searchUtils } from '../../utils'
import './Slider.sass'


class Slider extends Component {
  state = {
    slideVal: null,
    isPristine: true,
  }

  constructor() {
    super()
    this._onChange = this.onChange.bind(this)
    this._onBeforeChange = this.onBeforeChange.bind(this)
    this._onAfterChange = this.onAfterChange.bind(this)
  }

  componentDidMount() {
    // Find out how many slider IDs are in the IDs store and set default slider val
    const { options, activeFilterIds } = this.props
    const allSliderIds = options.map(opt => opt.id)
    const selectedSliderIds = _.intersection(activeFilterIds, allSliderIds)

    this.setState({ slideVal: selectedSliderIds.length ? selectedSliderIds.length - 1 : 0 })
  }

  componentWillReceiveProps(nextProps) {
    const { activeFilterIds, filterId } = this.props

    // Update local slider value to match redux's slider value
    if (nextProps.activeFilterIds.length !== activeFilterIds.length || nextProps.filterId !== filterId) {
      const allSliderIds = nextProps.options.map(opt => opt.id)
      const selectedSliderIds = _.intersection(nextProps.activeFilterIds, allSliderIds)

      this.setState({ slideVal: selectedSliderIds.length ? selectedSliderIds.length - 1 : 0 })

      // Handle external reset scenario -- if no longer any option IDs in the active filter list, we know to reset
      const activeFiltersIncludeSlider = nextProps.activeFilterIds.some(filterId => allSliderIds.includes(filterId))

      if (!activeFiltersIncludeSlider) {
        this.setState({ isPristine: true, slideVal: null })
      }
    }
  }

  getMarks(options = []) {
    // Build marks dynamically and bold the marks that are included in selected range
    // [{ 0: 'label1'}, { 1: 'label2'}, ...etc]
    return options.reduce((acc, option, idx) => {
      const isSelected = !this.state.isPristine && idx <= this.state.slideVal
      acc[idx] = isSelected ? <strong>{option.name}</strong> : option.name
      return acc
    }, {})
  }

  onBeforeChange(slideVal) {
    // On button press down
    this.setState({ isPristine: false })
  }

  onChange(slideVal) {
    // Update local state as sliding occurs
    this.setState({ slideVal })
  }

  onAfterChange(slideVal) {
    // Update redux state after sliding ends
    const { options, activeFilterIds, setActiveFilterIds, onUpdate } = this.props
    const selectedIds = options.slice(0, slideVal + 1).map(term => term.id)
    const unselectedIds = options.filter(opt => !selectedIds.includes(opt.id)).map(opt => opt.id)
    const updatedIds = searchUtils.getActiveFilterIds(activeFilterIds, selectedIds, unselectedIds)

    setActiveFilterIds(updatedIds)
    onUpdate(updatedIds)
  }

  render() {
    const { options, sliderClassName } = this.props
    const { slideVal, isPristine } = this.state

    return (
      <div className={`slider ${sliderClassName} ${isPristine ? 'slider__initial-style' : ''}`}>
        <RCSlider
          min={0}
          max={options.length - 1}
          marks={this.getMarks(options)}
          step={1}
          value={slideVal}
          onBeforeChange={this._onBeforeChange}
          onChange={this._onChange}
          onAfterChange={this._onAfterChange}
        />
      </div>
    )
  }
}

Slider.propTypes = {
  options: PropTypes.array,
  filterId: PropTypes.number,
  setActiveFilterIds: PropTypes.func,
  activeFilterIds: PropTypes.array,
  sliderClassName: PropTypes.string,
  onUpdate: PropTypes.func
}

Slider.defaultProps = {
  sliderClassName: 'slider-green',
  onUpdate: () => {}
}

export default Slider
